import { render, staticRenderFns } from "./HomeBanner.vue?vue&type=template&id=64b4b8d4&scoped=true"
import script from "./HomeBanner.vue?vue&type=script&lang=js"
export * from "./HomeBanner.vue?vue&type=script&lang=js"
import style0 from "./HomeBanner.vue?vue&type=style&index=0&id=64b4b8d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b4b8d4",
  null
  
)

export default component.exports